// r178 → r180 upgrade: this file was a full copy of the r161-dev PCDLoader.
// Replaced with a thin shim that re-exports the official r180 addons build.
// See libs/three.js/examples/jsm/loaders/PCDLoader.js for the actual implementation.
export { PCDLoader } from '../../libs/three.js/examples/jsm/loaders/PCDLoader.js';
